import { CreateplusTemplatesService } from "../../../common/api.service"
import ClientHelper from '../../../common/client.helper'

// アプリ内ブラウザ コンテンツ表示切り替えのためのEXE情報
let exeInfo = "";

export default {
  namespaced: true,
  state: {
    createplusCategories: [],
    createplusCategoriesStatus: false,
    createplusTemplates: [],
    createplusTemplatesStatus: false,
    createplusPaperSizes: [],
  },
  mutations: {
    setTemplates(state, payload) {
      // テンプレートのカテゴリ一覧（サブカテゴリ含む）
      let filterCategories = ClientHelper.filterCreateplusCategories(payload.categories, exeInfo)
      state.createplusCategories = filterCategories
      state.createplusCategoriesStatus = true
      // テンプレート一覧
      let filterTemplates = ClientHelper.filterCreateplusTemplates(payload.templates, exeInfo)
      state.createplusTemplates = filterTemplates
      state.createplusTemplatesStatus = true
      // 用紙サイズ一覧
      state.createplusPaperSizes = payload.papersizes
    }
  },
  actions: {
    async fetchTemplates({ commit }, {locale, exe}) {
      exeInfo = exe
      return await CreateplusTemplatesService.get(locale)
        .then(({ data }) => {
          commit("setTemplates", data)
          commit("setLocale", data.locale, { root: true })
          return data
        })
        .catch((reason) => {
          console.log(reason.message)
        })
    },
  },
  getters: {
    getSortSubCategories: (state) => (categoryId) => {
      let subCategories = state.createplusCategories.find(
        (category) => category.categoryID === categoryId
      ).subCategories;
      subCategories = Array.from(subCategories).sort((a, b) =>{
        if (a.subCategoryPriority === undefined || b.subCategoryPriority === undefined ){
          return 0
        }
        if (a.subCategoryPriority < b.subCategoryPriority) {
          return -1
        } else {
          return 1
        }
      })
      return subCategories
    }
  }
}
